import { CONTENT } from '../../shared/constants/content';
import { CONTENT_DE } from '../../shared/constants/content_de';

export class ContentUseCase {
  getAllContent(language: 'en' | 'de') {
    return language === 'de' ? CONTENT_DE : CONTENT;
  }

  getAppInfo(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.app;
  }

  getHomeContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.home;
  }

  getAboutUsContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.aboutUs;
  }

  getWhatIsMEContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.whatIsME;
  }

  getMitmachenContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.mitmachen;
  }

  getSocialMediaContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.socialMedia;
  }

  getDonationContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.donationInfo;
  }

  getLegalContent(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.legal;
  }

  getCookieBanner(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.legal.cookieBanner;
  }

  getCitations(language: 'en' | 'de') {
    const content = this.getAllContent(language);
    return content.citations;
  }
}

